import { render, staticRenderFns } from "./SpecialRegion.vue?vue&type=template&id=264355f4&lang=pug&"
import script from "./SpecialRegion.vue?vue&type=script&lang=js&"
export * from "./SpecialRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports